<template>
  <div>
    <Header />
    <TitlePage />
    <b-container>
      <b-row>
        <b-col cols="12"><h5>{{$t('คู่มือการใช้งานเว็บไซต์ ข่าวสดมาร์เก็ตเพลส')}}</h5></b-col>
      </b-row>
      <b-row>
        <b-col cols="12" md="3" :class="isMobile?'mobile-fixed':''">
          <b-list-group>
            <b-list-group-item
              href="#วิธีลงประกาศสินค้า"
              @click="updateScroll('วิธีลงประกาศสินค้า')"
              >
                {{$t('วิธีลงประกาศสินค้า')}}
              
            </b-list-group-item>
            <b-list-group-item
              href="#วิธีโปรโมตรายการสินค้า"
              @click="updateScroll('วิธีโปรโมตรายการสินค้า')"
              >{{$t('วิธีโปรโมตรายการสินค้า')}}

            </b-list-group-item>
            <b-list-group-item
              href="#วิธีการใช้โค้ดส่วนลด"
              @click="updateScroll('วิธีการใช้โค้ดส่วนลด')"
              >{{$t('วิธีการใช้โค้ดส่วนลด')}}
            </b-list-group-item>
            <b-list-group-item
              href="#วิธีโปรโมตรายการที่โพสไปแล้วของคุณ"
              @click="updateScroll('วิธีโปรโมตรายการที่โพสไปแล้วของคุณ')"
              >
                {{$t('วิธีโปรโมตรายการที่โพสไปแล้วของคุณ')}}
              </b-list-group-item>
              <b-list-group-item
               :to="$i18nRoute({ name: 'topics/become-company' })"
              >
                {{$t('ทำไมถึงต้องเปิดบัญชีในนามบริษัท')}}
              </b-list-group-item>
              <b-list-group-item
               :to="$i18nRoute({ name: 'topics/become-company' })"
              >
                {{$t('ทำไมถึงต้องเปิดบัญชีในนามบริษัท')}}
              </b-list-group-item>
              <b-list-group-item
               :to="$i18nRoute({ name: 'topics/become-company' })"
              >
                {{$t('ทำไมถึงต้องเปิดบัญชีในนามบริษัท')}}
              </b-list-group-item>
              <b-list-group-item
              :to="{path:$i18nRoute({ name: 'ads'}) ,query:{selected:2}}"
              >
                {{$t('ราคาแพ็กเกจ โปรโมทประกาศ')}}
              </b-list-group-item>
          </b-list-group>
        </b-col>

        <b-col  :class="isMobile?'mobile-scroll':'scroll-class'"
            :style="{'max-height':isMobile?windowHeight+'px':''}"
            >
            
          <b-row class="my-5">
            <b-col cols="12">
              <h3>{{$t('วิธีลงประกาศสินค้าฟรีง่าย ๆ ข่าวสดมาร์เก็ตเพลส')}}</h3>
              <p>{{$t('ข่าวสดมาร์เก็ตเพลส ให้คุณโพสรายการสินค้าต่าง ๆ ได้ฟรี ไม่มีเรียกเก็บย้อนหลัง ไม่มีหักเปอร์เซ็น')}}</p>
            </b-col>
          </b-row>
          <b-row class="my-5" id="วิธีลงประกาศสินค้า">
            <b-col cols="12" md="6"
              ><b-img
                left
                :src="`/images/activities/help/Post listing.png`"
                width="250"
                alt="Responsive image"
              ></b-img
            ></b-col>
            <b-col cols="12" md="6">
              <p>{{$t('กดปุ่มลงประกาศเพื่อประกาศขายสินค้า ที่คุณต้องการ')}}</p>
            </b-col>
          </b-row>
          <b-row class="my-5">
            <b-col cols="12" md="6"
              ><b-img
                left
                :src="`/images/activities/help/V2.png`"
                width="250"
                alt="Responsive image"
              ></b-img
            ></b-col>
            <b-col cols="12" md="6">
              <h5 class="my-4">
                {{$t('เลือกหมวดหมู่ให้ถูกต้องตามหมวด สินค้าของคุณ')}}
              </h5>
              <p>
                {{$t('หากรายการลงไม่ถูกต้องตามหมวดหมู่จะถูกปฎิเสธจากระบบและให้คุณแก้ไขหมวดหมู่ เพื่อลงประกาศอีกครั้ง')}}
              </p>

              <h5 class="my-4">{{$t('หัวข้อการลงประกาศ')}}</h5>
              <p>
                {{$t('ควรเขียนให้หัวข้อประกาศน่าสนใจและมีความ เกี่ยวข้องกับรายการสินค้าของคุณ')}}
              </p>
              <p>
                <strong> {{$t('ตัวอย่าง')}} </strong>{{$t('‘ขายโน้ตบุ๊กมือสอง ราคาถูก Asus Gaming TUF’')}}
              </p>
            </b-col>
          </b-row>
          <b-row class="my-5">
            <b-col cols="12" md="6"
              ><b-img
                left
                :src="`/images/activities/help/V3.png`"
                width="250"
                alt="Responsive image"
              ></b-img
            ></b-col>
            <b-col cols="12" md="6">
              <h5 class="my-4">{{$t('รูปภาพสินค้า')}}</h5>
              <p>
                {{$t('เลือกรูปภาพที่มีความคมชัด เห็นสินค้าชัดเจน และ มองเห็นในหลากหลายมุมมองเพื่อมีความน่าสนใจมากขึ้น')}}
              </p>
              <p>{{$t('(แนะนําภาพขนาด 1,200 x 675 pixel)')}}</p>
              <b-img
                class="my-4"
                :src="`/images/activities/help/Thairathclassifieds-05.png`"
                width="250"
                alt="Responsive image"
              ></b-img>
              <h5>{{$t('คีย์เวิร์ด')}}</h5>
              <p>
                {{$t('ใส่คีย์เวิร์ดที่มีความเกี่ยวข้องกับรายการสินค้าของคุณแล้วกด Enter')}}
              </p>
              <p>{{$t('‘คอนโด, คอนโดมือสอง, ขายคอนโด')}}</p>
            </b-col>
          </b-row>
          <b-row class="my-5">
            <b-col cols="12" md="6" class="my-4 text-center py-4"
              ><b-img
                left
                :src="`/images/activities/help/Post.png`"
                width="200"
                style="padding-left:50px"
                alt="Responsive image"
              ></b-img
            ></b-col>
            <b-col cols="12" md="6">
              <h5 class="my-3">{{$t('กดยืนยันการลงประกาศ')}}</h5>
              <p>
                {{$t('หลังจากที่กรอกข้อมูลต่าง ๆ เรียบร้อยแล้ว สามารถกดยืนยันเพื่อลงประกาศรายการสินค้าของคุณได้เลย')}}
              </p>
            </b-col>
          </b-row>
          <div class="divider"></div>
          <b-row class="my-5" id="วิธีโปรโมตรายการสินค้า">
            <b-col cols="12">
              <h3>{{$t('วิธีโปรโมตให้รายการของคุณมีคนเห็นมากขึ้น')}}</h3>
              <p>{{$t('แน่นอนว่าคู่แข่งที่ขายสินค้าของคุณมีมากมายหลายชิ้น หากคุณต้องการที่จะเพิ่มโอกาสให้คนเห็นสินค้าของคุณเยอะขึ้น สามารถโปรโมตรายการสินค้าของคุณได้เลยง่าย ๆ')}}</p>
            </b-col>
          </b-row>
          <b-row class="my-5">
            <b-col cols="12" md="6"
              ><b-img
                left
                :src="`/images/activities/help/V4.png`"
                width="250"
                alt="Responsive image"
              ></b-img
            ></b-col>
            <b-col cols="12" md="6">
              <h5 class="my-4">{{$t('เลือกแพ็กเกจที่คุณต้องการ')}}</h5>
              <p>{{$t('กดเลือกแพ็กเกจที่คุณต้องการ')}}</p>
              <img
                class="my-4"
                :src="`/images/activities/help/Promote Combo.png`"
              />
              <p>{{$t('เลือกระยะเวลาที่คุณต้องการโปรโมต')}}</p>
              <img
                class="my-4"
                :src="`/images/activities/help/option.png`"
              />
              <p>{{$t('หากคุณต้องการโปรโมตให้กดตกลงได้เลย')}}</p>
              <img
                :src="`/images/activities/help/no thanks.png`"
              />
            </b-col>
          </b-row>
          
          <b-row class="my-5">
            <b-col cols="12">
              <h5>{{$t('วิธีการชําระเงิน')}}</h5>
            </b-col>
          </b-row>
          <b-row class="my-5" align-v="center">
            <b-col cols="12" md="6"
              ><b-img
                left
                :src="`/images/activities/help/V5.png`"
                width="250"
                alt="Responsive image"
              ></b-img
            ></b-col>
            <b-col cols="12" md="6">
              <p>{{$t('กดเลือกวิธีการชําระเงินที่คุณต้องการ')}}</p>
            </b-col>
          </b-row>
          <b-row class="my-5" align-v="center">
            <b-col cols="12" md="6"
              ><b-img
                left
                :src="`/images/activities/help/V10.png`"
                width="250"
                alt="Responsive image"
              ></b-img
            ></b-col>
            <b-col cols="12" md="6">
              <p>
                {{$t('ตรวจสอบรายละเอียดแพ็กเกจพร้อมรายละเอียดอีกครั้งให ถูกต้องเรียบร้อย')}}
              </p>
              <b-img
                class="my-4"
                :src="`/images/activities/help/go to payment.png`"
                width="200"
                alt="Responsive image"
              ></b-img>
              <p>{{$t('หลังจากชําระเงินเรียบร้อย กดลงประกาศได้เลย')}}</p>
            </b-col>
          </b-row>
          
         
          <div class="divider"></div>
          <b-row class="my-5" id="วิธีการใช้โค้ดส่วนลด">
            <b-col cols="12"> 
              <h3>{{$t('วิธีการใช้โค้ดส่วนลด')}}</h3>
              <p>{{$t('หากคุณได้รับส่วนลดพิเศษจากกิจกรรมต่าง ๆ มาละก็ แล้วไม่รู้ว่าต้องใช้อย่างไร มาดูวิธีใช้ที่แสนง่ายได้เลยที่นี่')}}</p>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" md="6" class="my-4 py-4"
              ><b-img
                left
                :src="`/images/activities/help/discount.png`"
                width="200"
                alt="Responsive image"
                style="padding-left: 50px;"
              ></b-img
            ></b-col>
            <b-col cols="12" md="6">
              <h5 class="my-3">{{$t('กดยืนยันการลงประกาศ')}}</h5>
              <p>
                {{$t('หลังจากที่กรอกข้อมูลต่าง ๆ เรียบร้อยแล้ว สามารถกดยืนยันเพื่อลงประกาศรายการสินค้าของคุณได้เลย')}}
              </p>
            </b-col>
          </b-row>
          <b-row class="my-5" align-v="center">
            <b-col cols="12" md="6"
              ><b-img
                left
                :src="`/images/activities/help/V7.png`"
                width="250"
                alt="Responsive image"
              ></b-img
            ></b-col>
            <b-col cols="12" md="6">
              <p>
                {{$t('หากมีโค้ดส่วนลด สามารถใส่รหัสของส่วนลดที่ช่องด้านล่างพร้อมกด ใช้ส่วนลด')}}
              </p>
              <b-img
                center
                :src="`/images/activities/help/discount.png`"
                width="130"
                alt="Responsive image"
              ></b-img>
            </b-col>
          </b-row>
          <b-row class="my-5" align-v="center">
            <b-col cols="12" md="6"
              ><b-img
                left
                :src="`/images/activities/help/V8.png`"
                width="250"
                alt="Responsive image"
              ></b-img
            ></b-col>
            <b-col cols="12" md="6">
              <p>{{$t('หลังจากชําระเรียบร้อยแล้วจะแสดงข้อมูลดังรูปภาพ')}}</p>
            </b-col>
          </b-row>
          <b-row
            class="my-5"
            align-v="center"
            
          >
            <b-col cols="12" md="6"
              ><b-img
                left
                :src="`/images/activities/help/V9.png`"
                width="250"
                alt="Responsive image"
              ></b-img
            ></b-col>
            <b-col cols="12" md="6">
              <p>
                {{$t('กดลงประกาศเพื่อดูประกาศของคุณ เพียงเท่านี้ก็เสร็จ เรียบร้อย')}}
              </p>
            </b-col>
          </b-row>
          <div class="divider"></div>
          <b-row class="my-5" id="วิธีโปรโมตรายการที่โพสไปแล้วของคุณ">
            <b-col cols="12">
              <h3>
                {{$t('หากโพสประกาศไปแล้วแต่ต้องการโปรโมตรายการของคุณทีหลัง')}}
              </h3>
              <p>{{$t('หากคุณโพสประกาศไปแล้วและอยากจะโปรโมตรายการของคุณก็ทําาได้ง่าย ๆ ตามขั ้นตอนนี้เลย')}}</p>
            </b-col>
          </b-row>
          <b-row class="my-5">
            <b-col cols="12" md="6"
              ><b-img
                left
                :src="`/images/activities/help/V11.png`"
                width="250"
                alt="Responsive image"
              ></b-img
            ></b-col>
            <b-col cols="12" md="6">
              <p>
                {{$t('ไปที่รายการประกาศของคุณ')}}
                </p>
                <p>
                <a
                  id="faq-how-to-post-listing"
                  href="https://property.khaosod.co.th/th/user-manage/"
                  target="_blank"
                  style="color: #444"
                  >· {{$t('ประกาศอสังหาริมทรัพย์ (คลิกที่นี่)')}}</a
                ></p>
                <p>
               <a
                  id="faq-how-to-post-listing"
                  href="https://marketplace.khaosod.co.th/th/user-manage/"
                  target="_blank"
                  style="color: #444"
                  >· {{$t('ประกาศหมวดตลาด (คลิกที่นี่)')}}</a
                >
              </p>
              
              <p class="my-5 pa-0">
                <b-img
                  :src="`/images/activities/help/gear.png`"
                  alt="Responsive image"
                ></b-img
                >{{$t('คลิกที่เครื่องหมายเพื่อกดแก้ไขประกาศ หรือโปรโมต')}}
              </p>
              <b-img
                left
                class="my-5"
                :src="`/images/activities/help/edit.png`"
                alt="Responsive image"
              ></b-img>
            </b-col>
          </b-row>
          <b-row class="my-5">
            <b-col cols="12" md="6"
              ><b-img
                top
                :src="`/images/activities/help/V4.png`"
                width="250"
                alt="Responsive image"
              ></b-img
            ></b-col>
            <b-col cols="12" md="6">
              <h5 class="my-3">{{$t('เลือกแพ็กเกจที่คุณต้องการ')}}</h5>
              <p>{{$t('กดเลือกแพ็กเกจที่คุณต้องการ')}}</p>
              <b-img
                class="my-3"
                :src="`/images/activities/help/Promote Combo.png`"
                alt="Responsive image"
              ></b-img>
              <p>{{$t('เลือกระยะเวลาที่คุณต้องการโปรโมต')}}</p>
              <b-img
                class="my-3"
                :src="`/images/activities/help/option.png`"
                alt="Responsive image"
              ></b-img>
              <p>{{$t('หากคุณต้องการโปรโมตให้กดตกลงได้เลย')}}</p>
              <b-img
                left
                :src="`/images/activities/help/no thanks.png`"
                alt="Responsive image"
              ></b-img>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <Footer :adsFooter="adsFooter" />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Header from "@/components/ui/header";
import TitlePage from "@/components/ui/titlePage";
import Footer from "@/components/ui/footer";
import { Trans } from '@/plugins/Translation';
export default {
  name: "Activities",
  components: {
    Header,
    TitlePage,
    Footer
  },
  data() {
    return {
      adsFooter: null,
      windowHeight:window.innerHeight - 435
    };
  },
  computed: {
    ...mapGetters("UserController", [ "isMobile"]),
    selectedLanguage(){
			return Trans.currentLanguage
		}
  },
  mounted() {
       this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
      this.onResize();
    });
  },
  methods: {
    updateScroll(elemenetId) {
      setTimeout(function () {
        document
          .getElementById(elemenetId)
          .scrollIntoView({ behavior: "smooth" });
      }, 700);
    },
    onResize(){
        this.windowHeight=window.innerHeight - 435
    }
  },
};
</script>
<style scoped lang="scss">
.mobile-scroll{
    overflow-y: scroll;
    margin-top: 200px;
}
.scroll-class{
max-height: 884px; overflow-y: scroll
}
.mobile-fixed{
    position: fixed;
}
.divider {
			height: 2px;
			border-top: 2px solid var(--projectPrimaryColor);
		}
</style>